import React, { useEffect, useState } from "react";

import { DashboardFilterType, ProductRatio } from "@/types/dashboard";

import { getDashboardBidFilterToString } from "@/consts/Dashboard";

import { GetStatsByContractAmount } from "@/services/Dashboard";

import { showToast } from "@/utils/toastUtils";
import { cn, formatKoreanCurrencyWithWon } from "@/libs/utils";

import DashboardCardHeader from "@/components/DashboardCardHeader";

type Props = {
  title: string;
  searchReady: boolean;
  filter: DashboardFilterType;
  onSearchComplete: () => void;
};

export default function DashboardTopTenList({
  title,
  searchReady,
  filter,
  onSearchComplete,
}: Props) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<ProductRatio[]>([]);
  const onLoad = async () => {
    try {
      setIsLoading(true);
      const params = getDashboardBidFilterToString(filter);
      const result = await GetStatsByContractAmount(params);
      if (result.data.success) {
        const newData = result.data.pods[0].content.items.map((item) => ({
          label: item.company_name,
          value: item.contract_amount,
        }));
        setData(newData);
      } else {
        showToast({
          type: "error",
          message: `${title}을(를) 조회하는데 실패했습니다. ${result.data.error.type}`,
        });
      }
    } catch (e) {
      showToast({
        type: "error",
        message: `${title}을(를) 조회하는데 실패했습니다. ${e}`,
      });
    } finally {
      setIsLoading(false);
      onSearchComplete();
    }
  };

  useEffect(() => {
    if (searchReady) {
      onLoad();
    }
  }, [searchReady]);

  return (
    <DashboardCardHeader title={title} isLoading={isLoading}>
      <div
        className={cn("max-h-fit overflow-y-auto divide-y divide-gray-100", {
          "h-full max-h-full flex justify-center items-center": data.length < 1,
        })}
      >
        {data.length > 0 ? (
          data.map((item, index) => (
            <div
              key={index}
              className="flex justify-between py-2 text-[10px] text-gray-A font-bold"
            >
              <span className="truncate">{item.label}</span>
              <span className="text-gray-B font-semibold">
                {formatKoreanCurrencyWithWon(item.value)}
              </span>
            </div>
          ))
        ) : (
          <div className="text-gray-B text-sm">
            해당 검색 조건으로 결과가 없습니다.
          </div>
        )}
      </div>
    </DashboardCardHeader>
  );
}
